import Colors from '../../../../shared/assets/style/default/color';
import Fonts from '../../../../shared/assets/style/default/fonts';
import Screen from '../../../../shared/utils/screen';
import styled from 'styled-components';

const ErrorTitleText = styled.div<React.CSSProperties>`
  color: ${Colors['light']};
  font-family: ${Fonts['regular']};
  font-size: ${100 * Screen.widthRatio}px;
  margin-top: ${230 * Screen.widthRatio}px;
  text-align: center;
`;

export default ErrorTitleText;
